<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 2a1 1 0 00-1 1v3H3a1 1 0 000 2h4a1 1 0 001-1V3a1 1 0 00-1-1zM21 16h-4a1 1 0 00-1 1v4a1 1 0 002 0v-3h3a1 1 0 000-2zM17 8h4a1 1 0 000-2h-3V3a1 1 0 00-2 0v4a1 1 0 001 1zM7 16H3a1 1 0 000 2h3v3a1 1 0 002 0v-4a1 1 0 00-1-1zM14 9h-4a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1zm-1 4h-2v-2h2z"/></svg>